// extracted by css-extract-rspack-plugin
export default {"moreChartsHeader":"uLK7s"};